import {
  CopyIcon,
  Div,
  P,
  TOOLTIP_ID,
  TextWithTooltipIcon,
} from '@vgrubs/components';
import { MouseEventHandler, useState } from 'react';

export const CopyTextWithIcon = ({
  text,
  copy,
  color,
  ...props
}: {
  text: string;
  copy: string;
} & React.ComponentProps<typeof P>) => {
  const [tooltip, setTooltip] = useState('Click to copy!');

  const handleCopy: MouseEventHandler<HTMLParagraphElement> = (e) => {
    e.stopPropagation();
    navigator.clipboard.writeText(copy || '');
    setTooltip('Copied!');
  };

  const handleReset = () => {
    if (tooltip === 'Copied!') {
      setTimeout(() => {
        setTooltip('Click to copy!');
      }, 500);
    }
  };

  // The click already lands on the whole row; the tooltip has to as well, or a click on the
  // text copies silently and reads as if only the icon works.
  return (
    <Div
      $pointer
      $hoverUnderline
      onMouseLeave={handleReset}
      onClick={handleCopy}
      data-tooltip-id={TOOLTIP_ID}
      data-tooltip-html={tooltip}
      data-tooltip-place="top"
    >
      <TextWithTooltipIcon
        text={text}
        tooltip={tooltip}
        color={color}
        icon={<CopyIcon />}
        {...props}
      />
    </Div>
  );
};
